import styled from 'styled-components';

export const Main = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  padding-bottom: 24px;
`;

export const Loading = styled.div`
  display: flex;
  justify-content: center;
`;
